import { render, staticRenderFns } from "./OldLabelPrinting.vue?vue&type=template&id=9406ff6e&"
import script from "./OldLabelPrinting.vue?vue&type=script&lang=js&"
export * from "./OldLabelPrinting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports